import { render } from "./Column202412.vue?vue&type=template&id=68b3eafa&scoped=true"
import script from "./Column202412.vue?vue&type=script&lang=js"
export * from "./Column202412.vue?vue&type=script&lang=js"

import "./Column202412.vue?vue&type=style&index=0&id=68b3eafa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-68b3eafa"

export default script